// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2jlbE","search":"Settings_search__1IsxQ","filter":"Settings_filter__3n-ct"};